import { AppHelper } from "../appHelper";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../core/components/commonApp";
import { EntityUserSettingsApply, UserSettingsApply, UserSettingsApplyAppProps } from "./userSettingsApply";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { Helper } from "../core/util/helper";
import { Commands } from "../core/util/commandManager";
import { General } from "../../siteManagement/general";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { UserSettingsGeoMapRouteResultGraduation } from "./userSettingsGeoMapRouteResultGraduation";
import { GeoMapRouteResultGraduation } from "../core/util/resourcePlanningHelper";
import { SheetEventType } from "../../siteManagement/sheet";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Grid } from "../core/components/grid";
import ServerTemplateExecuteApp from "../serverTemplate/serverTemplateExecute";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { DialogHelper } from "../core/util/dialogHelper";
import React from "react";
export class UserSettingsApp extends React.Component<UserSettingsAppProps, UserSettingsAppState> {
    common = new AppHelper();
    noBookmark = true;
    setTabTitle = true;
    translations = [];
    copyEnabled: boolean = false;
    useAddresstypePermission: boolean;
    deleteRoleEnabled = false;
    deleteUserEnabled = false;
    isReloDeleted = false;
    private _user: string = null; // Eigener user
    private _currentUser: string = null; // User der gerade in Bearbeitung ist
    private _timeResolutionTypes = {
        "Hours": 0,
        "Days": 1,
        "Week": 2,
        "Month": 3
    }
    constructor(props: UserSettingsAppProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.useAddresstypePermission = Helper.getValueOrDefault(props.useAddresstypePermission, false);
        this.copyEnabled = props.entity.RecordRight.UserConfiguration;

        this._user = Config.user.userName;
        this._currentUser = props.entity.User.Name;
        this.state = {
            isGeoMapRouteResultGraduationDialogOpen: false,
            selectedGeoMapRouteResultGraduation: null,
            GeoMapRouteResultGraduations: props.entity.GeneralSettings.Geomap_FilterRouteResultGraduation
        };

        this.handleFieldChange({ model: "entity.GeneralSettings.IsExtern" }, props.entity.GeneralSettings.IsExtern, null, true);
        this.refreshRoleDeleteEnabled();
        this.refreshUserDeleteEnabled();
    }

    private refreshRoleDeleteEnabled() {
        this.deleteRoleEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }

    private refreshUserDeleteEnabled() {
        this.deleteUserEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }

    save = (closeAfterSave) => {
        if (this.common.validate()) {
            HTTPService.post("UserSettings/Save", this.props.entity)
                .then(result => {
                    
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.GeneralSettings.Password", null);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.GeneralSettings.PasswordRepeat", null);
                    
                    if (result.Code === 0) {
                        this.props.entity.IsNew = false;
                        this.common.commandManager.runCommand("entity.User.Name", Commands.REFRESH);
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }

                    //check ok?
                    if (result.Code === 0) {
                        //check user is loggen in user 
                        if (this._user === this._currentUser) {
                            //check password changed => do logout
                            if (Helper.hasValue(this.props.entity.GeneralSettings.Password) &&
                                Helper.hasValue(this.props.entity.GeneralSettings.PasswordRepeat)) {
                                setTimeout(() => {
                                    document.getElementById('logout-form__trigger').click();
                                }, 1000);
                            } else //reload self
                            {
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "UserSettings/Edit";
                                }, 1000);
                            }
                        } else {
                            //reload editable user
                            this.handleFieldChange({ model: "entity.User.Name" }, this._currentUser, null);
                            return;
                        }
                    }

                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                });
        }
    }
    openApply = () => {
        if (this.common.entityChanged) {
            NotificationHelper.showInfoMessage(Config.translations.saveDataFirst);
        } else {
            const sheet = General.Sheet.Manager.createSheet();
            sheet.setTitle(this.translations["WebCRM.Administration.BenutzereinstellungenKopieren"]);

            let entityApply: EntityUserSettingsApply = {
                IsNew: false,
                RecordRight: { CanRead: true, CanWrite: true },
                Type: "",
                Users: [],
                Groups: [],
                MainGroups: [],
                NewUserName: null,
                IsWatchable: false,
                IsWatched: false,
                NewRoleName: null,
                IsRole: false,
                UserName: null
            };
            const props: UserSettingsApplyAppProps = {
                context: this.props.context,
                dataSources: this.props.dataSources,
                title: this.translations["WebCRM.Administration.BenutzereinstellungenKopieren"],
                metadata: this.props.metadataUserSettingsApply,
                entity: entityApply,
                userName: this.props.entity.User.Name,
                isWindow: true,
                handleMenuSelect: null,
                enableMenuItem: null,
                handleCreateValidator: null,
                handleFieldChange: null,
                handleDataLoaded: null,
                onChange: null
            };

            let loadUser = false;
            sheet.bind(SheetEventType.SavedSuccessfully, () => {
                if (entityApply.Type === "n") {
                    loadUser = true;
                }
            });
            sheet.bind(SheetEventType.Close, () => {
                if (loadUser && !this.common.entityChanged) {
                    this.handleFieldChange({ model: "entity.User.Name" }, entityApply.NewUserName);
                }
            });
            sheet.show(() => {
                sheet.mountContent(UserSettingsApply, props);
            });
        }
    }

    openRoleApply = () => {
        if (this.common.entityChanged) {
            NotificationHelper.showInfoMessage(Config.translations.saveDataFirst);
        } else {
            const sheet = General.Sheet.Manager.createSheet();
            sheet.setTitle(this.translations["WebCRM.Administration.RoleKopieren"]);

            let entityApply: EntityUserSettingsApply = {
                IsNew: false,
                RecordRight: { CanRead: true, CanWrite: true },
                Type: "",
                Users: [],
                Groups: [],
                MainGroups: [],
                NewUserName: null,
                IsWatchable: false,
                IsWatched: false,
                NewRoleName: null,
                IsRole: true,
                UserName: null
            };
            const props: UserSettingsApplyAppProps = {
                context: this.props.context,
                dataSources: this.props.dataSources,
                title: this.translations["WebCRM.Administration.RoleKopieren"],
                metadata: this.props.metadataUserSettingsApply,
                entity: entityApply,
                userName: this.props.entity.User.Name,
                isWindow: true,
                handleMenuSelect: null,
                enableMenuItem: null,
                handleCreateValidator: null,
                handleFieldChange: null,
                handleDataLoaded: null,
                onChange: null
            };

            let loadUser = false;
            sheet.bind(SheetEventType.SavedSuccessfully, () => {
                if (entityApply.Type === "r") {
                    loadUser = true;
                }
            });
            sheet.bind(SheetEventType.Close, () => {
                if (loadUser && !this.common.entityChanged) {
                    this.handleFieldChange({ model: "entity.User.Name" }, entityApply.NewRoleName);
                }
            });
            sheet.show(() => {
                sheet.mountContent(UserSettingsApply, props);
            });
        }
    }

    public deleteRole = async () => {
        let isOk = await DialogHelper.confirm(Config.translations.delete + "?");
        if (!isOk) return;

        HTTPService.post<JsonResultClass>('UserSettings/DeleteRole?role=' + encodeURIComponent(this.props.entity.User.Name))
            .then(result => {
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                    if (this.common.isWindow) {
                        this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                        this.common.sheetWrapper.hide();
                    } else {
                        this.isReloDeleted = true;
                        this.deleteRoleEnabled = false;
                        this.props.entity.RecordRight.CanWrite = false;
                        this.setState({});
                        setTimeout(() => {
                            window.location.href = Config.baseUrl + "DynamicSearch/roles";
                        }, 1000);
                    }
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    public deleteUser = async () => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteUserWarn + "<br\>" + Config.translations.delete + " [" + this.props.entity.User.Name + "]?");
        if (!isOk) return;

        HTTPService.post<JsonResultClass>('UserSettings/DeleteUser?user=' + encodeURIComponent(this.props.entity.User.Name))
            .then(result => {
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                    if (this.common.isWindow) {
                        this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                        this.common.sheetWrapper.hide();
                    } else {
                        this.deleteUserEnabled = false;
                        this.props.entity.RecordRight.CanWrite = false;
                        this.setState({});
                        setTimeout(() => {
                            window.location.href = Config.baseUrl + "UserSettings/Edit";
                        }, 1000);
                    }
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    openGeoMapRouteResultGraduationDialog = (e: React.MouseEvent<HTMLLIElement>, key: number) => {
        let selectedlevel = null;
        if (key) {
            selectedlevel = this.props.entity.GeneralSettings.Geomap_FilterRouteResultGraduation.filter((rg) => {
                return rg.threshold === key;
            })[0];
        }

        this.setState({ isGeoMapRouteResultGraduationDialogOpen: true, selectedGeoMapRouteResultGraduation: selectedlevel });
    }
    saveGeoMapRouteResultGraduation = (routeResultGraduation: GeoMapRouteResultGraduation) => {
        if (routeResultGraduation.threshold != null && routeResultGraduation.color != null) {
            let lst = this.state.GeoMapRouteResultGraduations.map((rg) => {
                if (rg.threshold === routeResultGraduation.threshold) {
                    rg = { ...routeResultGraduation };
                }
                return rg;
            });
            let index = lst.findIndex(f => f.id == routeResultGraduation.id);
            if (index == -1 || lst.length === 0) {
                lst.push(routeResultGraduation);
            } else {
                lst[index] = routeResultGraduation;
            }
            lst = lst.sort((a, b) => {
                if (a.threshold < b.threshold) {
                    return -1;
                }
                if (a.threshold > b.threshold) {
                    return 1;
                }
                return 0;
            })

            //if (lst.length === 0 || lst.every(rg => rg.threshold !== routeResultGraduation.threshold)) {
            //    lst.push(routeResultGraduation);
            //}
            this.setState({ GeoMapRouteResultGraduations: lst }, () => {
                this.handleFieldChange({ model: "entity.GeneralSettings.Geomap_FilterRouteResultGraduation" }, this.state.GeoMapRouteResultGraduations, null, false);
            });
        }
    }

    executeLinkOAuth = () => {
        window.location.replace(Config.baseUrl + "Account/LinkOAuthUser");
    }

    executeUnlinkOAuth = async () => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("WebSMS.UserSettings.UnlinkOAuthUser") + "?");
        if (isOk) {
            const userName = this.props.entity.User.Name;
            window.location.replace(Config.baseUrl + "Account/UnlinkOAuthUser?userName=" + encodeURIComponent(userName));
        }
    }

    executeServerTemplate = async () => {
        const sheet = General.Sheet.Manager.createSheet();

        let url = 'ServerTemplate/InitExecuteTemplate?Ressnr=' + encodeURIComponent(this.props.entity.GeneralSettings.Resource) + '&Templateid=3&RessourceTyp=1';
        const results = await Promise.all([
            HTTPService.get(url),
            Helper.getMetaData("serverTemplateExecute")
        ]);

        sheet.show(() => {
            const servertemplateexecutevm = results[0].Data;
            const metadata = results[1];
            const props = {
                title: "",
                entity: servertemplateexecutevm,
                context: { contextType: "serverTemplateExecute", translations: null },
                metadata: metadata,
                executeTemplate: true,
                doNotUpdateBrowserTitle: false
            } as any;
            sheet.mountContent(ServerTemplateExecuteApp, props);
        });

    }
    deleteGeoMapRouteResultGraduation = (threshold: number) => {
        let lst = this.state.GeoMapRouteResultGraduations.filter((rg) => {
            return rg.threshold != threshold;
        });
        this.setState({ GeoMapRouteResultGraduations: lst }, () => {
            this.handleFieldChange({ model: "entity.GeneralSettings.Geomap_FilterRouteResultGraduation" }, this.state.GeoMapRouteResultGraduations, null, false);
        });
    }
    setOpenStatus = (status: boolean) => {
        this.setState({ isGeoMapRouteResultGraduationDialogOpen: status });
    }
    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        let minValue: number;

        switch (field.model) {
            case "entity.ResourcePlanningSettings.FixierungHorizontal":
                if (value && this.props.entity.ResourcePlanningSettings.FixierungVertikal)
                    this.props.entity.ResourcePlanningSettings.FixierungVertikal = false;
                break;
            case "entity.ResourcePlanningSettings.FixierungVertikal":
                if (value && this.props.entity.ResourcePlanningSettings.FixierungHorizontal)
                    this.props.entity.ResourcePlanningSettings.FixierungHorizontal = false;
                break;
            case "entity.ResourcePlanningSettings.ProjektplanListProjNr":
                let lst = value as {}[];
                const index = lst.findIndex(f => Object.keys(f).length == 2);
                if (index > -1) {
                    let alreadyAvailable: boolean = false;
                    for (let i = 0; i < lst.length; i++) {
                        if (i != index) {
                            if (lst[i]["Beschreibung"] == lst[index]["Beschreibung"]) {
                                alreadyAvailable = true;
                                break;
                            }
                        }
                    }
                    if (alreadyAvailable) {
                        let message: string = this.translations["WebSMS.UserSettings.ProjectAlreadyExists"];
                        message = message.replace('{projNr}', lst[index]["Beschreibung"]);
                        NotificationHelper.showErrorMessage(message);
                        lst = lst.map((value, i) => {
                            if (index != i) {
                                return value
                            } else {
                                return null;
                            }
                        }).filter(f => Helper.hasValue(f))
                    } else {
                        let item = lst[index];
                        item["Bemerkung"] = null;
                        item["Delete"] = false;
                        lst[index] = item;
                    }
                    value = lst;
                }
                break;
            case "entity.GeneralSettings.IsExtern":
                MetaDataHelper.setRequired(this.props.metadata, "entity.GeneralSettings.DefaultAdrNr", value);
                MetaDataHelper.setRequired(this.props.metadata, "entity.GeneralSettings.DefaultAnsprechpartnerPos", value);
                break;
            case "entity.User.Name":
                isInit = true;
                HTTPService.get("UserSettings/Get/?id=" + encodeURIComponent(value))
                    .then(data => {
                        if (!this.props.entity.RecordRight.UserAdmin && data.Data.GeneralSettings.RechtSystem === 2) {
                            NotificationHelper.showErrorMessage(this.translations["Rechte.UnzureichendeBerechtigungen"]);
                        }
                        else {
                            this._currentUser = value;
                            Helper.updateEntity(this.props.entity, data.Data);
                            this.handleFieldChange({ model: "entity.GeneralSettings.IsExtern" }, this.props.entity.GeneralSettings.IsExtern, null, true);
                            this.common.handleFieldChange(field, value, dataItem);
                            this.setState({ GeoMapRouteResultGraduations: this.props.entity.GeneralSettings.Geomap_FilterRouteResultGraduation });
                            this.common.handlePostSave(true);
                        }
                    });
                break;
            case "entity.GeneralSettings.ExtendedLogin":
                if (value && (this.props.entity.GeneralSettings.ExtendedLoginUsername === null || this.props.entity.GeneralSettings.ExtendedLoginUsername === "")) {
                    this.props.entity.GeneralSettings.ExtendedLoginUsername = this.props.entity.User.Name;
                }
                break;
            case "entity.ResourcePlanningSettings.AnzahlVorhergegangendeZellen":
                let maxValue: number = 0;
                switch (this.props.entity.ResourcePlanningSettings.ZoomModus) {
                    case (this._timeResolutionTypes.Hours):
                        maxValue = this.props.entity.ResourcePlanningSettings.AnzahlZellenStunden;
                        break;
                    case (this._timeResolutionTypes.Days):
                        maxValue = this.props.entity.ResourcePlanningSettings.AnzahlZellenTage;
                        break;
                    case (this._timeResolutionTypes.Week):
                        maxValue = this.props.entity.ResourcePlanningSettings.AnzahlZellenWochen;
                        break;
                    case (this._timeResolutionTypes.Month):
                        maxValue = this.props.entity.ResourcePlanningSettings.AnzahlZellenMonate;
                        break;
                }
                if (maxValue <= value) {
                    value = this.props.entity.ResourcePlanningSettings.AnzahlVorhergegangendeZellen;
                    let message: string = this.translations["WebSMS.UserSettings.Units.InvalidInput"];
                    NotificationHelper.showWarningMessage(message.replace("{x}", maxValue.toString()));
                }
                break;
            case "entity.ResourcePlanningSettings.AnzahlZellenTage":
                minValue = this.props.entity.ResourcePlanningSettings.AnzahlVorhergegangendeZellen;
                if (value < minValue) {
                    value = this.props.entity.ResourcePlanningSettings.AnzahlZellenTage;
                    let message: string = this.translations["WebSMS.UserSettings.Units.InvalidInput"];
                    NotificationHelper.showWarningMessage(message.replace("{x}", value.toString()));
                }
                break;
            case "entity.ResourcePlanningSettings.AnzahlZellenWochen":
                minValue = this.props.entity.ResourcePlanningSettings.AnzahlVorhergegangendeZellen;
                if (value < minValue) {
                    value = this.props.entity.ResourcePlanningSettings.AnzahlZellenWochen;
                    let message: string = this.translations["WebSMS.UserSettings.Units.InvalidInput"];
                    NotificationHelper.showWarningMessage(message.replace("{x}", value.toString()));
                }
                break;
            case "entity.ResourcePlanningSettings.AnzahlZellenMonate":
                minValue = this.props.entity.ResourcePlanningSettings.AnzahlVorhergegangendeZellen;
                if (value < minValue) {
                    value = this.props.entity.ResourcePlanningSettings.AnzahlZellenMonate;
                    let message: string = this.translations["WebSMS.UserSettings.Units.InvalidInput"];
                    NotificationHelper.showWarningMessage(message.replace("{x}", value.toString()));
                }
                break;
            case "entity.ResourcePlanningSettings.EinsaetzeFiltern":
                if (value) {
                    this.handleFieldChange({ model: "entity.ResourcePlanningSettings.OnlyContainerAssignments" }, false);
                }
                break;
            case "entity.ResourcePlanningSettings.OnlyContainerAssignments":
                if (value) {
                    this.handleFieldChange({ model: "entity.ResourcePlanningSettings.EinsaetzeFiltern" }, false);
                }
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private _saveInternal = async () => {
        if (!this.common.entityChanged) return true;

        let isOk = await DialogHelper.confirm(Helper.getTranslation("WebSMS.Ticket.SaveRequired"));
        if (!isOk) return false;

        isOk = this.common.validate();
        if (!isOk) return false;

        const result = await HTTPService.post("UserSettings/Save", this.props.entity);
        if (result.Code === 0) {
            this.props.entity.IsNew = false;
            NotificationHelper.showSuccessMessage(result.Message);
            return true;
        } else {
            NotificationHelper.showErrorMessage(result.Message);
            return false;
        }
    }

    private addRoleUser = async () => {
        if (!await this._saveInternal()) return;
        const sheet = General.Sheet.Manager.createSheetWithUrl(`DynamicSearch/Window/user?fullObject=true&multi=true&displayPattern=[[name]]`, { disableTabTitle: true });
        sheet.bind(SheetEventType.ItemsSelected, this.sheetBindingSetItemsSelectedRoleUser);
    }

    private addUserRole = async () => {
        if (!await this._saveInternal()) return;

        const sheet = General.Sheet.Manager.createSheetWithUrl(`DynamicSearch/Window/roles?fullObject=true&multi=true&displayPattern=[[name]]`, { disableTabTitle: true});
        sheet.bind(SheetEventType.ItemsSelected, this.sheetBindingSetItemsSelectedUserRole);
    }
    sheetBindingSetItemsSelectedRoleUser = async (ev: { data: [] }) => {
        let selectedUsers: any[] = [];
        ev.data.forEach((dataRow: any) => {
            if (this.props.entity.RoleUsers.findIndex(s => s.Name == dataRow["name"]) < 0) {
                this.props.entity.RoleUsers.push({
                    Name: dataRow["name"],
                    FullName: dataRow["name2"]
                });
            }
        });
        this.setState({}, () => this.save(false));
    };
    sheetBindingSetItemsSelectedUserRole = async (ev: { data: [] }) => {
        let selectedUsers: any[] = [];
        ev.data.forEach((dataRow: any) => {
            if (this.props.entity.User.Roles.findIndex(s => s.Name == dataRow["name"]) < 0) {
                this.props.entity.User.Roles.push({
                    Name: dataRow["name"],
                    FullName: dataRow["name2"]
                });
            }
        });
        this.setState({}, () => this.save(false));
    };

    private deleteRoleUser = async (names: string[] | string) => {
        let isOk = await DialogHelper.confirm(Config.translations.delete + "?");
        if (!isOk) return;
        if (!await this._saveInternal()) return;
        if (Array.isArray(names)) {
            this.props.entity.RoleUsers = this.props.entity.RoleUsers.filter(i => {
                return !names.includes(i.Name)
            });
        }
        else {
            this.props.entity.RoleUsers = this.props.entity.RoleUsers.filter(i => i.Name != names);
        }
        this.setState({}, () => this.save(false));
    }

    private deleteUserRole = async (names: string[] | string) => {
        let isOk = await DialogHelper.confirm(Config.translations.delete + "?");
        if (!isOk) return;

        if (!await this._saveInternal()) return;
        if (Array.isArray(names)) {
            this.props.entity.User.Roles = this.props.entity.User.Roles.filter(i => {
                return !names.includes(i.Name)
            });
        }
        else {
            this.props.entity.User.Roles = this.props.entity.User.Roles.filter(i => i.Name != names);
        }
        this.setState({}, () => this.save(false));
    }

    private roleUsersClick = async (type: ToolBarStandardButtonType, dataItems: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            await this.addRoleUser();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            if (Array.isArray(dataItems)) {
                await this.deleteRoleUser(dataItems.map(i => i.Name));
            }
            else {
                await this.deleteRoleUser(dataItems.Name);
            }
            
        }
    }

    private userRolesClick = async (type: ToolBarStandardButtonType, dataItems: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            await this.addUserRole();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            if (Array.isArray(dataItems)) {
                await this.deleteUserRole(dataItems.map(i => i.Name));
            }
            else {
                await this.deleteUserRole(dataItems.Name);
            }
            
        }
    }

    renderAssignedUsers = () => {
        let options: kendo.ui.GridOptions = {
            resizable: true,
            pageable: false,
            sortable: false,
            filterable: false,
            selectable: "multiple, row",
            columns: [
                { field: "Name", title: this.translations["WebSMS.UserSettings.LoginName"] },
                { field: "FullName", title: this.translations["WebSMS.UserSettings.Name"] }
            ]
        };

        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this.translations["Standard.Neu"], enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this.translations["Standard.Loeschen"], enabled: true });

        // customButtons={customButtons} onClickCustomButton={this._onButtonClick} standardButtons={stdButtons} 
        //                   onClickStandardButton={this._handleClickStandardButton} 
        //                   onSelectionChanged={this.handleSelectionChanged} 

        return (
            <>
                <div className={"flex-container flex-container__item"}>
                    <Grid data={this.props.entity.RoleUsers} options={options} id="Role_AssignedUsers"
                        standardButtons={standardButtons}
                        onClickStandardButton={this.roleUsersClick} />
                </div>
            </>);
    }

    renderAssignedRoles = () => {
        let options: kendo.ui.GridOptions = {
            resizable: true,
            pageable: false,
            sortable: false,
            filterable: false,
            selectable: "multiple, row",
            columns: [
                { field: "Name", title: this.translations["WebCRM.Administration.Role"] },
                { field: "FullName", title: this.translations["WebSMS.PartsList.ArtName"] }
            ]
        };

        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this.translations["Standard.Neu"], enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this.translations["Standard.Loeschen"], enabled: true });

        return (
            <>
                <div className={"flex-container flex-container__item"}>
                    <Grid data={this.props.entity.User.Roles} options={options} id="User_AssignedRoles"
                        standardButtons={standardButtons}
                        onClickStandardButton={this.userRolesClick} />
                </div>
            </>);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        if (this.props.context.contextType == "userSettings")
            props.dc4ModuleName = "app/userSettings/userSettingsSelectUser";

        return <>
            <CommonApp {...props} />
            <UserSettingsGeoMapRouteResultGraduation
                geoMapRouteResultGraduation={this.state.selectedGeoMapRouteResultGraduation}
                saveRouteResultGraduation={this.saveGeoMapRouteResultGraduation}
                deleteRouteResultGraduation={this.deleteGeoMapRouteResultGraduation}
                dialogOpen={this.state.isGeoMapRouteResultGraduationDialogOpen}
                setOpenStatus={this.setOpenStatus}
                translations={this.translations}
            />
        </>;
    }
};

export interface UserSettingsAppState {
    isGeoMapRouteResultGraduationDialogOpen: boolean;
    selectedGeoMapRouteResultGraduation: GeoMapRouteResultGraduation;
    GeoMapRouteResultGraduations: Array<GeoMapRouteResultGraduation>;
}

export interface UserSettingsAppProps extends AppBaseProps {
    entity: EntityUserSettings;
    metadataUserSettingsApply: Metadata;
    useAddresstypePermission?: boolean;
}

export interface EntityUserSettings extends Entity {
    RoleUsers: UserEntity[];
    User: { Name: string, Sprache: Number, Roles: UserEntity[] };
    GeneralSettings:
    {
        IsExtern: boolean,
        ExtendedLoginUsername: string,
        Geomap_FilterRouteResultGraduation?: Array<any>,
        Password: string,
        PasswordRepeat: string,
        Resource: string
    };
    ResourcePlanningSettings: {
        FixierungVertikal: boolean;
        FixierungHorizontal: boolean;
        AnzahlZellenStunden: number;
        AnzahlZellenTage: number;
        AnzahlZellenWochen: number;
        AnzahlZellenMonate: number;
        AnzahlVorhergegangendeZellen: number;
        ZoomModus: number;
        DateFormatAtMoving: string
    }
    WeeklyReportSettings: {
        DeleteWeeklyReport: boolean;
    }
    RecordRight: {
        CanRead: boolean;
        CanWrite: boolean;
        UserConfiguration: boolean;
        UserAdmin: boolean;
    }
}

interface UserEntity {
    Name: string;
    FullName: string;
}